import React, { useMemo } from 'react';
import './index.css';
import dart from './dart.svg';
import { FcCheckmark } from "react-icons/fc";
import {store} from "../../../index";

function MyStats({ drivingNotes, onSelectNoteIndex }) { // HERE!!!! Accepts onSelectNoteIndex prop
    const uniqueGroupIds = useMemo(() => {
        if (!drivingNotes || drivingNotes.length === 0) return [];
        // Sort ascending lexicographically to get a consistent order for numbering
        const ids = Array.from(new Set(drivingNotes.map(note => note.groupId))).sort((a, b) => a.localeCompare(b));
        return ids.reverse(); // Reverse for the desired display order (newest group ID first)
    }, [drivingNotes]);

    const totalGroups = uniqueGroupIds.length; // Need total groups for calculation


    return (
        <div className="stats-container">
            {/* Map over unique group IDs to create a stat item for each group */}
            {uniqueGroupIds.map((groupId, index) => {
                const groupNotes = drivingNotes.filter(note => note.groupId === groupId);
                const totalDoneInGroup = groupNotes.filter(note => note.isDone).length;
                const totalApprovedInGroup = groupNotes.reduce((total, note) => {
                    const statuses = [
                        note.statA, note.statB, note.statC, note.statD, note.statE,
                        note.statF, note.statG, note.statH, note.statI,
                    ];
                    const approvedCount = statuses.filter(status => status === '🟢Godkänd').length;
                    return total + approvedCount;
                }, 0);
                const count = totalGroups - index;

                const firstNoteIndexForGroup = drivingNotes.findIndex(note => note.groupId === groupId);

                return (
                    <section key={groupId} className="stat-item">
                        <img src={dart} style={{ width: '42px', marginBottom: '8px' }} alt={'progress_icon'} />

                        <h3>Övningskort nummer </h3>
                        <b>
                            <p className={'bold center'}>
                                <FcCheckmark style={{ marginRight: '2px'}} />
                                {count}</p>
                        </b>
                        <h3>Totalt avklarade lektioner:</h3>
                        <p className={'bold center'}>
                            <FcCheckmark style={{ marginRight: '2px'}} />
                            {totalDoneInGroup} av 4
                        </p>
                        <h3>Totalt godkända delmoment:</h3>
                        <p className={'bold center'}>
                            <FcCheckmark style={{ marginRight: '2px' }} />
                            {totalApprovedInGroup} av {store.user && store.user.autotransmission !== undefined ? (store.user.autotransmission ? 12 : 16) : '?'} delmoment
                        </p>
                        {uniqueGroupIds.length > 1 && firstNoteIndexForGroup !== -1 && count > 0 && (
                            <button
                                className="ghostbuttonXS mt-8"
                                onClick={() => onSelectNoteIndex(firstNoteIndexForGroup)}
                                style={{ maxWidth: '120px' }}
                            >
                                Gå till kort {count}
                            </button>
                        )}
                    </section>
                );
            })}
        </div>
    );
}

export default MyStats;